import React, { useEffect, useState } from "react";
import { Container, Spinner, Table } from "react-bootstrap";
import ComponentMenu from "../../components/layout/ComponentMenu";
import ComponentTitle from "../../components/layout/ComponentTitle";
import {
  MdOutlineEdit,
  MdDeleteOutline,
  MdAddCircleOutline,
  MdOutlineWorkspaces,
} from "react-icons/md";
import { FaCar } from "react-icons/fa";
import ModalCreateUpdate from "../../components/admin/localisation/ModalCreateUpdate";
import { useSelector } from "react-redux";
import { apiGetLocalisations } from "../../api/ApiLocalisation";
import ModalDelete from "../../components/admin/localisation/ModalDelete";
import ModalSpaces from "../../components/admin/localisation/ModalSpaces";
import { useTranslation } from "react-i18next";
import ModalMobilities from "../../components/admin/localisation/ModalMobilities";

const PageAdminLocalisations = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const [localisations, setLocalisations] = useState([]);
  const [idLocalisation, setIdLocalisation] = useState("");

  const [showCreateUpdate, setShowCreateUpdate] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showSpaces, setShowSpaces] = useState(false);
  const [showMobilities, setShowMobilities] = useState(false);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    recupLocalisations();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleShowCreateUpdate = (id) => {
    setIdLocalisation(id);
    setShowCreateUpdate(true);
  };

  const handleCloseCreateUpdate = () => {
    setIdLocalisation(null);
    setShowCreateUpdate(false);
  };

  const handleShowDelete = (id) => {
    setIdLocalisation(id);
    setShowDelete(true);
  };
  const handleCloseDelete = () => {
    setIdLocalisation(null);
    setShowDelete(false);
  };

  const handleShowSpaces = (id) => {
    setIdLocalisation(id);
    setShowSpaces(true);
  };

  const handleShowMobilities = (id) => {
    setIdLocalisation(id);
    setShowMobilities(true);
  };

  const handleCloseSpaces = () => {
    setIdLocalisation(null);
    setShowSpaces(false);
  };

  const handleCloseMobilities = () => {
    setIdLocalisation(null);
    setShowMobilities(false);
  };

  const recupLocalisations = async () => {
    setLoading(true);
    const res = await apiGetLocalisations(ReduxInstance._id);
    if (res) {
      setLocalisations(res.data);
      setLoading(false);
    } else {
      console.log("Error");
    }
  };

  return (
    <>
      <ComponentMenu />
      <Container>
        <ComponentTitle title={t("admin.PageAdminLocalisations.titre")} />
        <span role="button" onClick={() => handleShowCreateUpdate("")}>
          <MdAddCircleOutline size="1.5em" />{" "}
          {t("admin.PageAdminLocalisations.buttonAjouterLocalisation")}
        </span>
        {loading ? (
          <div style={{ textAlign: "center", flex: 1 }}>
            <Spinner animation="grow" />
          </div>
        ) : (
          <Table striped bordered hover className="stickyTable mt-2">
            <thead>
              <tr>
                <th>{t("admin.PageAdminLocalisations.titreColonne1")}</th>
                <th>{t("admin.PageAdminLocalisations.titreColonne2")}</th>
                <th className="text-center">{t("admin.PageAdminLocalisations.titreColonne3")}</th>
                <th className="text-center">{t("admin.PageAdminLocalisations.titreColonne6")}</th>
                <th className="text-center">{t("admin.PageAdminLocalisations.titreColonne4")}</th>
                <th className="text-center">{t("admin.PageAdminLocalisations.titreColonne5")}</th>
              </tr>
            </thead>
            <tbody>
              {localisations.map((localisation) => (
                <tr key={localisation._id}>
                  <td>{localisation.nom}</td>
                  <td>{localisation.pays}</td>
                  <td className="text-center">
                    <MdOutlineWorkspaces
                      size="1.5em"
                      role="button"
                      onClick={() => handleShowSpaces(localisation._id)}
                    />
                  </td>
                  <td className="text-center">
                    <FaCar
                      size="1.5em"
                      role="button"
                      onClick={() => handleShowMobilities(localisation._id)}
                    />
                  </td>
                  <td className="text-center">
                    <MdOutlineEdit
                      size="1.5em"
                      role="button"
                      onClick={() => handleShowCreateUpdate(localisation._id)}
                    />
                  </td>
                  <td className="text-center">
                    <MdDeleteOutline
                      size="1.5em"
                      role="button"
                      onClick={() => handleShowDelete(localisation._id)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
        <ModalCreateUpdate
          show={showCreateUpdate}
          id={idLocalisation}
          handleClose={handleCloseCreateUpdate}
          handleRecupDatas={recupLocalisations}
        />
        <ModalDelete
          show={showDelete}
          id={idLocalisation}
          handleClose={handleCloseDelete}
          handleRecupDatas={recupLocalisations}
        />
        <ModalSpaces show={showSpaces} id={idLocalisation} handleClose={handleCloseSpaces} />
        <ModalMobilities
          show={showMobilities}
          id={idLocalisation}
          handleClose={handleCloseMobilities}
        />
      </Container>
    </>
  );
};

export default PageAdminLocalisations;
